module.exports = __webpack_public_path__ + "img/1.fffd9590.jpg";